module.exports = __webpack_public_path__ + "img/logo.22c464c8.png";